import useBannerData from "hook/useBannerData";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import {useSettings} from "../../context/SettingsContext";
import { assetUrl } from "utils/api";

const Banner = () => {
    const { theme } = useSettings();
    const isDark = theme === "dark";
  const { banners, loadingBanner } = useBannerData();
  if (loadingBanner) {
    return (
        <div className="relative md:max-w-7xl mx-auto px-4 sm:px-4 2xl:px-0 lg:px-8 pt-4 md:pb-4 pb-0">

            <div
                className={`w-full h-[150px] sm:h-[220px] md:h-[300px] lg:h-[400px] rounded-md overflow-hidden relative
    ${isDark ? "bg-slate-800" : "bg-gray-300"}`}
            >
                {/* Shimmer */}
                <div
                    className={`absolute inset-0 animate-shimmer bg-[length:200%_100%]
      ${
                        isDark
                            ? "bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800"
                            : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
                    }`}
                />
            </div>

        </div>
    );
  }

  if (!banners || banners.length === 0) {
    return null;
  }
  return (
    <div className="relative md:max-w-7xl mx-auto  p-4 2xl:px-0 lg:px-8 md:pb-4 pb-0 rounded-2xl">
      <Swiper
        modules={[Autoplay, Navigation]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        loop={true}
        speed={800}
        spaceBetween={0}
        slidesPerView={1}
        className="w-full h-[150px]  md:h-[270px] lg:h-[370px] rounded-2xl"
      >
        {banners.map((slide) => (
          <SwiperSlide key={slide.banner_id}>
            <Link to={slide.link}>
              <div className="relative w-full h-full rounded-2xl">
                <img
                  src={assetUrl(slide.image_path)}
                  alt={slide.title}
                  className="w-full h-full object-fit rounded-2xl"
                  draggable="false"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </Link>
          </SwiperSlide>
        ))}

        {/* <button
          className="custom-prev absolute left-4 top-1/2 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white rounded-full md:w-10 w-8 md:h-10 h-8 flex items-center justify-center transition-all duration-300 shadow-lg"
          aria-label="Previous slide"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="md:h-6 h-4 md:w-6 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          className="custom-next absolute right-4 top-1/2 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white rounded-full md:w-10 w-8 md:h-10 h-8 flex items-center justify-center transition-all duration-300 shadow-lg"
          aria-label="Next slide"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="md:h-6 h-4 md:w-6 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button> */}
      </Swiper>
    </div>
  );
};
export default Banner;
